const initRecaptchaV3 = () => {
    const recaptchaInput = document.querySelector('input.recaptcha-v3');

    if (recaptchaInput) {
        // Polyfill for Element.prototype.closest
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                let el = this;

                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }

        // Get the siteId from meta.recaptcha-site-id
        const siteId = document
            .querySelector('meta[name="recaptcha-site-id"]')
            .getAttribute('content');

        // Get the form that surrounds input.recaptcha-v3
        const recaptchaForm = recaptchaInput.closest('form');

        // Handle recaptcha and obtain token before submitting the form
        // grecaptcha will be available since that will be in global scope
        // before this script is run
        recaptchaForm.addEventListener('submit', e => {
            // Prevent the form from submitting
            e.preventDefault();
            // Run recaptcha to obtain a token
            // eslint-disable-next-line no-undef
            grecaptcha.ready(() => {
                // Add the token the hidden recaptcha input and then submit the form
                // eslint-disable-next-line no-undef
                grecaptcha
                    .execute(siteId, { action: 'homepage' })
                    .then(token => {
                        recaptchaInput.setAttribute('value', token);
                        recaptchaForm.submit();
                    });
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', initRecaptchaV3);

//make the script available for classic JS scripts on the HTML page
if (typeof window.allnex === "undefined") {
    window.allnex = {};
}
window.allnex.initRecaptchaV3 = initRecaptchaV3;
